import { BOOST_CATEGORY } from '@packages/types';

import { useBoostDetailsStore, useFeatureFlagsStore, useGlobalStore, useTripStore } from '@store';

useTripStore.subscribe(
  state =>
    `${state?.trip?.boosts?.find?.(it => it.category === BOOST_CATEGORY.MY_HEALTH)?.boostId} ${state?.trip?.tripType}`,
  async (currentBoostIdAndTripType, previousBoostIdAndTripType) => {
    const [currentBoostId, currentTripType] = currentBoostIdAndTripType?.split(' ') || [];
    const [previousBoostId, previousTripType] = previousBoostIdAndTripType?.split(' ') || [];
    if (currentTripType !== previousTripType) {
      // If the trip type has changed, we may need to reset some state
      useBoostDetailsStore.getState().clearMandatoryBoostDetails();
    }
    const getBoostDetails = useBoostDetailsStore.getState().getBoostDetails;
    if (!currentBoostId || currentBoostId === previousBoostId) {
      return;
    }
    await getBoostDetails(currentBoostId);
  },
);

useTripStore.subscribe(
  state => state?.trip?.boosts?.find?.(it => it.code === 'CANX'),
  async newBoost => {
    const setIsExtraCancellationAddedByDefaultForCanstar =
      useGlobalStore.getState().setIsExtraCancellationAddedByDefaultForCanstar;
    const canstarExtraCancellationPayload =
      useFeatureFlagsStore.getState().featureFlags?.[
        'extra-cancellation-added-by-default-for-canstar-tooltip'
      ]?.payload;
    if (
      newBoost?.isAdded &&
      newBoost?.boostProperty?.selectedExtraCover !==
        canstarExtraCancellationPayload?.canstarCanxAmount
    ) {
      setIsExtraCancellationAddedByDefaultForCanstar(false);
    }
  },
);
